import styled from 'styled-components';

export const ActivityTimerWrapper = styled.div`
	display: flex;
	justify-content: center;
	flex-direction: column;
	height: 18px;
`;

export const AgeLimitWrapper = styled.div`
	display: flex;
	justify-content: center;
	flex-direction: column;
	height: 18px;
	text-align: center;
`;

export const AgeLimitContent = styled.span`
	color: rgba(var(--base-12), 1);
	font: var(--small);
`;

export const RegulationSideWrapper = styled.div`
	display: block;
	height: auto;
	width: 60px;
`;

export const CurrentTime = styled.span`
	color: rgba(var(--base-12), 1);
	font: var(--small);
`;
